import { useQuery } from '@tanstack/react-query';
import { getBankAddressStep } from '../requests';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';

type Props = {
  templateId?: string;
  enabled?: boolean;
};

export function useGetBankAddressStep({
  templateId,
  enabled = true,
}: Props = {}) {
  const query = useQuery({
    queryKey: ['operations', 'bank', 'withdraw', 'params', templateId],
    queryFn: () => getBankAddressStep(templateId),
    enabled: enabled,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
